import { Apis } from "../../lib/Apis";

export const useBlogCategory = () => {
    const addBlogCategories = async (data) => {
        try {
            const response = await Apis.addCategoryBlog(data);
            return response.data;
        } catch (error) {
            console.error("Error adding blog category:", error);
            throw error;
        }
    }
    const getBlogCategories = async (setBlogCategories, setTotal, offset = 0, limit = 10, name = "", status = "") => {
        try {
            const params = {};
            
            if (name && name.trim()) {
                params.name = name.trim();
            }
            
            if (status !== "") {
                params.status = status === "true" ? true : false;
            }

            const response = await Apis.getBlogCategories(offset, limit, params);
            if (response?.status === 200) {
                setBlogCategories(response.data.data);
                // Extract total from pagination object
                const totalRecords = response.data.pagination?.totalCount || response.data.data.length;
                setTotal(totalRecords);
                return response.data;
            } else {
                throw new Error(response?.data?.message || "Failed to fetch blog categories.");
            }
        } catch (error) {
            console.error("Error fetching blog categories:", error);
            throw error;
        }
    }

    const searchBlogCategories = async (name, status, offset = 0, limit = 10) => {
        try {
            const params = {};
            
            if (name && name.trim()) {
                params.name = name.trim();
            }
            
            if (status !== "") {
                params.status = status === "true" ? true : false;
            }

            const response = await Apis.getBlogCategories(offset, limit, params);
            return response.data;
        } catch (error) {
            console.error("🚀 ~ file: useHook.js ~ line 64 ~ searchBlogCategories ~ error", error);
            return error;
        }
    };
    const updateBlogCategory = async (id, data) => {
        try {
            const response = await Apis.updateBlogCategory(id, data);
            return response.data;
        } catch (error) {
            console.error("Error updating blog category:", error);
            throw error;
        }
    }
    const deleteBlogCategory = async (id) => {
        try {
            const response = await Apis.deleteBlogCategory(id);
            return response.data;
        } catch (error) {
            console.error("Error deleting blog category:", error);
            throw error;
        }
    }
    const updateCategoryStatus = async (id, status) => {
        try {
            const response = await Apis.updateBlogCategoryStatus(id, status);
            return response.data;
        } catch (error) {
            console.error("Error updating category status:", error);
            throw error;
        }
    };
    const getBlogByCategoryId = async (id, setBlogs) => {
        try {
            const response = await Apis.getBlogCategoryById(id);
            setBlogs(response.data.blogs);
            return response;
        } catch (error) {
            console.error("Error fetching blog category by id:", error);
            throw error;
        }
    }
    return { addBlogCategories, getBlogCategories, updateBlogCategory, deleteBlogCategory, updateCategoryStatus, getBlogByCategoryId, searchBlogCategories };
}